import React, { useState } from 'react';
import { TickOneIcon } from '../../atoms/icons';
import ImageSlider from './image-slider';
import {
  OneFacebookIcon,
  OneInstagramIcon,
  OneTikTokIcon,
} from '../../atoms/icons';
import { redirectToProductDetails } from '../../../utils';
import NoImage from '../../../assets/images/no-image.png';
import defaultAvatar from '../../../assets/images/default-avatar.jpg';
import VideoSlider from './video-slider';

export const TemplateTwo = ({
  expertiseData,
  preferredBrands,
  preferredProducts,
  redirectToBuyerPortal,
  redirectToShopPortal,
  cardDetails,
  schedulerEnabled,
}) => {
  const { seller, storefront } = cardDetails?.current?.config;
  const LogoUrl =
    storefront?.general?.longLogoImage?.url ||
    storefront?.general?.logoImage?.url ||
    null;

  const [isExpanded, setIsExpanded] = useState(false);
  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <>
      <div className="two-theme">
        <section className="two-header">
          <div className="wrapper-two">
            <header className="flex justify-between items-center gap-6">
              {LogoUrl ? (
                <div className="logo-box max-w-56">
                  <img src={LogoUrl} alt="logo" />
                </div>
              ) : (
                <h2 className="logo-text text-twoPrimary pl-1 capitalize">
                  {storefront?.general?.name}
                </h2>
              )}
            </header>
          </div>
          <div className="two-top-body flex md:flex-row flex-col">
            <div className="stylish_wrp">
              <div className="stylish_box flex gap-4 flex-1  items-center md:px-14 pb-0 md:flex-row flex-col">
                <div className="profile-logo">
                  <img
                    src={
                      seller?.profile?.avatar?.mediumUrl ||
                      seller?.profile?.avatar?.url ||
                      defaultAvatar
                    }
                    alt="picture"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = defaultAvatar;
                    }}
                  />
                </div>
                <div className="mobile-view">
                  <h2 className="text-black-main font-bold  text-4xl font-tempOne capitalize break-words line-clamp-6 text-ellipsis overflow-hidden">
                    {seller?.profile?.title}
                  </h2>

                  <div className="long-text">
                    <div
                      className={
                        isExpanded
                          ? 'full-text'
                          : seller?.profile?.about?.length > 600
                          ? 'clamped-text'
                          : ''
                      }
                    >
                      <p
                        className="font-bold text-xl mt-5 font-tempOne two-text-dec cus-bdr-l after:bg-primary"
                        dangerouslySetInnerHTML={{
                          __html: seller?.profile?.about,
                        }}
                      />
                    </div>
                    {seller?.profile?.about?.length > 600 && (
                      <div className="text-right">
                        <button
                          className="text-twoPrimary read-text"
                          onClick={toggleReadMore}
                        >
                          {isExpanded ? 'Read Less' : 'Read More'}
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="social-icon">
                    {seller?.profile?.facebookUrl && (
                      <a
                        href={seller?.profile?.facebookUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cursor-pointer"
                      >
                        <OneFacebookIcon className="text-twoPrimary" />
                      </a>
                    )}
                    {seller?.profile?.instagramUrl && (
                      <a
                        href={seller?.profile?.instagramUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cursor-pointer"
                      >
                        <OneInstagramIcon className="text-twoPrimary" />
                      </a>
                    )}
                    {seller?.profile?.tiktokUrl && (
                      <a
                        href={seller?.profile?.tiktokUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cursor-pointer"
                      >
                        <OneTikTokIcon className="text-twoPrimary" />
                      </a>
                    )}
                  </div>
                  <button
                    className="text-white-main font-bold text-xl mt-10 px-10 py-4 rounded-TwoCustom bg-twoPrimary"
                    onClick={() =>
                      redirectToShopPortal(storefront?.general?.shopUrl)
                    }
                  >
                    Shop the store
                  </button>
                </div>
              </div>
            </div>
            <div className="info-box flex-1 md:flex ">
              <div>
                {preferredProducts?.length ? (
                  <div
                    className={
                      preferredProducts?.length === 0
                        ? 'visibility-hidden'
                        : 'visibility-auto'
                    }
                  >
                    <h2 className="text-white-main font-semibold text-2xl font-tempOne mt-6 mb-5  text-center">
                      My Favorite Products
                    </h2>
                    <div className="flex gap-4 flex-wrap justify-center">
                      {preferredProducts?.slice(0, 4).map((product, index) => (
                        <div
                          key={index}
                          className="image-wrp cursor-pointer"
                          onClick={() =>
                            redirectToProductDetails(
                              storefront?.general?.shopUrl +
                                '/products/' +
                                product?.slug
                            )
                          }
                        >
                          <img
                            src={
                              product?.primaryImage?.mediumUrl ||
                              product?.primaryImage?.thumbUrl ||
                              NoImage
                            }
                            alt={`Product ${index + 1}`}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                ) : preferredBrands?.length ? (
                  <div
                    className={
                      preferredBrands?.length === 0
                        ? 'visibility-hidden'
                        : 'visibility-auto'
                    }
                  >
                    <h2 className="text-white-main font-semibold text-2xl font-tempOne mt-6 mb-5  text-center">
                      My Favorite Brands
                    </h2>
                    <div className="flex gap-4 flex-wrap justify-center">
                      {preferredBrands?.slice(0, 4).map((product, index) => (
                        <div
                          key={index}
                          className="image-wrp cursor-pointer"
                          onClick={() =>
                            redirectToProductDetails(
                              storefront?.general?.shopUrl +
                                '/brands/' +
                                product?.slug
                            )
                          }
                        >
                          <img
                            src={
                              product?.coverImage?.mediumUrl ||
                              product?.coverImage?.thumbUrl ||
                              NoImage
                            }
                            alt={`Product ${index + 1}`}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="box-wrp two-gallery pb-4">
            {expertiseData?.length ? (
              <div
                className={
                  expertiseData?.length === 0
                    ? 'visibility-hidden'
                    : 'visibility-auto'
                }
              >
                <h2 className="font-semibold text-2xl font-tempOne mt-7 mb-5 text-center md:text-left">
                  Expertise
                </h2>
                <ul className="columns-2">
                  {expertiseData?.map((item, index) => (
                    <li key={index} className="flex items-center mb-2">
                      <TickOneIcon className="text-twoPrimary" />
                      <span className="ml-2.5 font-normal text-base">
                        {item?.name}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <div
                className={
                  seller?.profile?.expertise
                    ? 'visibility-auto'
                    : 'visibility-hidden'
                }
              >
                <h2 className=" font-semibold text-2xl font-tempOne mt-7 mb-5 text-center md:text-left">
                  Expertise
                </h2>
                <p
                  className="mt-5 font-tempOne border-twoPrimary "
                  dangerouslySetInnerHTML={{
                    __html: seller?.profile?.expertise,
                  }}
                />
              </div>
            )}
            {schedulerEnabled && (
              <div className="text-center mt-6">
                <button
                  className="text-white-main font-bold text-xl px-10 py-4 rounded-TwoCustom bg-twoPrimary"
                  onClick={() => redirectToBuyerPortal()}
                >
                  Book an appointment
                </button>
              </div>
            )}
          </div>
        </section>

        {seller?.profile?.galleryImages?.length ? (
          <section className="two-gallery pb-5 md:pb-14">
            <h2 className="text-black-main font-semibold text-2xl font-tempOne mt-7 mb-5 md:text-left text-center">
              Salon Gallery
            </h2>
            <div className="image-slider">
              <ImageSlider images={seller?.profile?.galleryImages} />
            </div>
          </section>
        ) : (
          <></>
        )}
        {seller?.profile?.galleryVideoLinks?.length ? (
          <>
            <section className="two-gallery">
              <h2 className="text-black-main font-semibold text-2xl font-tempOne mb-5 md:text-left text-center">
                Salon Videos
              </h2>
              <div className="image-slider">
                <VideoSlider videos={seller?.profile?.galleryVideoLinks} />
              </div>
            </section>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};
